// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"hqW9jjTKY4KjhKJiSDux","buttonsWrapper":"fZDfs2JXlA0eK1CmPPLz","button":"ChjHkvVjYzMCFJaZwzf8","icon":"MdQBgS7fSAAuY7aErC7Q"};